// Handle checkbox change event for cross-selling
document.addEventListener("change", function (event) {
    var checkbox = event.target;

    if (
        checkbox.matches(
            '#cross_selling .checkbox-round input[type="checkbox"]'
        )
    ) {
        var variantId = checkbox.value;
        var isChecked = checkbox.checked;

        // Record current scroll position
        var scrollContainer = document.querySelector(
            "#slider-cross-selling"
        );
        var currentScrollLeft = scrollContainer
            ? scrollContainer.scrollLeft
            : 0;

        if (isChecked) {
            // Add to cart
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    // Mark as added and keep checkbox checked
                    checkbox.setAttribute(
                        "data-added",
                        "true"
                    );
                    checkbox.checked = true;
                    checkbox.parentElement.classList.add(
                        "checked"
                    );

                    // Update cart count
                    var cartCount = document.querySelector(
                        ".cart-link__count"
                    );
                    if (cartCount) {
                        var currentCount =
                            parseInt(
                                cartCount.textContent,
                                10
                            ) || 0;
                        cartCount.textContent =
                            currentCount + 1;
                    } else {
                        // Create cart count element if it doesn't exist
                        var cartLinkIcon =
                            document.querySelector(
                                ".cart-link__icon"
                            );
                        if (cartLinkIcon) {
                            var newCartCount =
                                document.createElement(
                                    "span"
                                );
                            newCartCount.className =
                                "cart-link__count";
                            newCartCount.textContent = "1";
                            cartLinkIcon.appendChild(
                                newCartCount
                            );
                        }
                    }

                    // Trigger cart update event
                    if (
                        typeof window.theme !==
                            "undefined" &&
                        window.theme.cart
                    ) {
                        window.theme.cart.updateCount();
                    }
                    document.dispatchEvent(
                        new CustomEvent("cart:updated")
                    );
                })
                .catch((error) => {
                    console.error(
                        "Error adding to cart:",
                        error
                    );
                    checkbox.checked = false;
                });
        } else {
            // Remove from cart
            fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 0,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    // Mark as not added and uncheck
                    checkbox.setAttribute(
                        "data-added",
                        "false"
                    );
                    checkbox.checked = false;
                    checkbox.parentElement.classList.remove(
                        "checked"
                    );

                    // Update cart count
                    var cartCount = document.querySelector(
                        ".cart-link__count"
                    );
                    if (cartCount) {
                        var currentCount =
                            parseInt(
                                cartCount.textContent,
                                10
                            ) || 0;
                        var newCount = Math.max(
                            0,
                            currentCount - 1
                        );
                        if (newCount === 0) {
                            // Remove cart count element when count is 0
                            cartCount.remove();
                        } else {
                            cartCount.textContent =
                                newCount;
                        }
                    }

                    // Trigger cart update event
                    if (
                        typeof window.theme !==
                            "undefined" &&
                        window.theme.cart
                    ) {
                        window.theme.cart.updateCount();
                    }
                    document.dispatchEvent(
                        new CustomEvent("cart:updated")
                    );
                })
                .catch((error) => {
                    console.error(
                        "Error removing from cart:",
                        error
                    );
                    checkbox.checked = true;
                });
        }

        // Restore scroll position
        setTimeout(function () {
            if (scrollContainer) {
                scrollContainer.scrollLeft =
                    currentScrollLeft;
            }
        }, 0);
    }
});

// Allow clicking on the image to toggle checkbox
document
    .querySelectorAll("#cross_selling img")
    .forEach(function (img) {
        img.addEventListener("click", function (e) {
            // Record current scroll position
            var scrollContainer = document.querySelector(
                "#slider-cross-selling"
            );
            var currentScrollLeft = scrollContainer
                ? scrollContainer.scrollLeft
                : 0;

            var container = e.currentTarget.closest(
                ".scrollable_item"
            );
            var checkbox = container.querySelector(
                ".checkbox-round input"
            );

            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event("change"));

            // Restore scroll position
            setTimeout(function () {
                if (scrollContainer) {
                    scrollContainer.scrollLeft =
                        currentScrollLeft;
                }
            }, 0);
        });
    });
